import React from 'react'
import styled from '@emotion/styled'
import { stylesIf, themeColor } from 'utils/styles'
import { ifElse, prop } from 'ramda'
import Paragraph from '../../Typography/Paragraph'
import Button from '../../Button'

export const StyledTab = styled.div`
  min-width: 40px;
  cursor: pointer;
  text-align: center;
  position: relative;
  padding-bottom: 5px;
  padding-left: 10px;
  padding-right: 10px;
  flex-shrink: 0;
  display: flex;
  align-items: flex-start;
  height: 48px;
  color: ${ifElse(
    prop('selected'),
    themeColor('paragraphColor'),
    themeColor('harnessTabUnselectedColor')
  )};
  &:after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    margin-left: 10px;
    width: ${(props) =>
      props.isUndefined || !props.editable
        ? `calc(100% - 20px)`
        : `calc(100% - 45px)`};
    height: 4px;
    ${(props) => stylesIf(props.selected, `background: #0a5e7a;`)}
  }
`

export const Title = styled(({ className, children }) => (
  <Paragraph className={className} size="large">
    {children}
  </Paragraph>
))`
  color: inherit;
`

export const Subtitle = styled(({ className, children }) => (
  <Paragraph className={className}>{children}</Paragraph>
))`
  color: inherit;
`

export const RemoveButton = styled(({ className, onClick }) => (
  <Button
    type="icon"
    className={className}
    iconProps={{ icon: 'cancel', size: 10 }}
    onClick={onClick}
  />
))`
  && {
    margin: 0 0 0 4px;
  }
`
